// Environment configuration for dashboard

/**
 * API Base URL configuration
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dev-sakti.gbs.id/api/insight';

/**
 * API endpoints configuration
 */
export const API_CONFIG = {
  // Base URLs
  BASE_URL: API_BASE_URL,

  // Endpoints
  ENDPOINTS: {
    DATE_RANGE: '/odoo/api/produksi/date-range',
    PRODUCTION_TBS: '/odoo/onepage-dashboard/production-tbs',
    PRODUCTION_PKS: '/odoo/onepage-dashboard/production-pks',
    STOCK_CPO_PK: '/odoo/onepage-dashboard/stock-cpo-pk',
    PKS_SORTATION: '/odoo/onepage-dashboard/pks-sortation',
    SOLAR_USAGE: '/odoo/onepage-dashboard/solar-usage',
    CPO_PK_DELIVERY: '/odoo/onepage-dashboard/cpo-pk-delivery',
    HARVEST_ATTENDANCE: '/odoo/onepage-dashboard/harvest-attendance'
  },

  // Request configuration 
  // timeout 5 minutes
  TIMEOUT: 5 * 60 * 1000, // 5 minutes

  // Retry configuration
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 second
};

/**
 * Dashboard configuration
 */
export const DASHBOARD_CONFIG = {
  // Update intervals (in milliseconds)
  AUTO_REFRESH_INTERVAL: 60 * 60 * 1000, // 60 minutes
  // 10 seconds for development
  DEVELOPMENT_AUTO_REFRESH_INTERVAL: 10 * 1000, // 10 seconds

  // Chart animation settings
  CHART_ANIMATION: {
    DURATION: 1000,
    EASING: 'ease-in-out'
  },

  // Date format settings
  DATE_FORMATS: {
    DISPLAY: 'DD/MM/YYYY',
    API: 'YYYYMMDD',
    INPUT: 'YYYY-MM-DD'
  },

  // Grid settings
  GRID: {
    COLUMNS: {
      MOBILE: 1,
      TABLET: 2,
      DESKTOP: 3
    },
    GAP: 6
  },

  // Performance settings
  DEBOUNCE_DELAY: 500, // 500ms for search/filter inputs

  // Chart settings
  CHART_HEIGHTS: {
    SMALL: 200,
    MEDIUM: 300,
    LARGE: 400
  },

  // Responsive heights for different screen sizes
  RESPONSIVE_HEIGHTS: {
    LAPTOP: 'calc(100vh - 80px)',
    MONITOR: 'calc(100vh - 90px)',
    TV: '100vh',
    LARGE_TV: '100vh'
  }
};

/**
 * Feature flags
 */
export const FEATURE_FLAGS = {
  // Enable/disable features
  ENABLE_AUTO_REFRESH: true,
  ENABLE_EXPORT: true,
  ENABLE_FILTERS: true,
  ENABLE_TOOLTIPS: true,
  ENABLE_ANIMATIONS: true,

  // Development features
  ENABLE_MOCK_DATA: process.env.NODE_ENV === 'development',
  ENABLE_DEBUG_MODE: process.env.NODE_ENV === 'development',
  ENABLE_PERFORMANCE_MONITORING: false
};

/**
 * Theme configuration
 */
export const THEME_CONFIG = {
  // Color schemes
  COLORS: {
    PRIMARY: '#4A5A33',
    SECONDARY: '#6B7B4A',
    SUCCESS: '#22C55E',
    WARNING: '#F59E0B',
    ERROR: '#EF4444',
    INFO: '#3B82F6'
  },

  // Typography
  FONTS: {
    HEADING: 'Inter, sans-serif',
    BODY: 'Inter, sans-serif',
    MONO: 'JetBrains Mono, monospace'
  },

  // Spacing
  SPACING: {
    XS: 4,
    SM: 8,
    MD: 16,
    LG: 24,
    XL: 32
  },

  // Border radius
  BORDER_RADIUS: {
    SM: 4,
    MD: 8,
    LG: 12,
    XL: 16
  }
};

/**
 * Validation rules
 */
export const VALIDATION_RULES = {
  DATE_RANGE: {
    MAX_DAYS: 365, // Maximum days in date range
    MIN_DAYS: 1    // Minimum days in date range
  },

  NUMBERS: {
    MIN_VALUE: 0,
    MAX_DECIMAL_PLACES: 2
  }
};

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Terjadi kesalahan jaringan. Silakan coba lagi.',
  API_ERROR: 'Terjadi kesalahan pada server. Silakan coba lagi.',
  DATA_NOT_FOUND: 'Data tidak ditemukan.',
  INVALID_DATE_RANGE: 'Rentang tanggal tidak valid.',
  LOADING_ERROR: 'Gagal memuat data. Silakan refresh halaman atau klik tombol Refresh.',
  EXPORT_ERROR: 'Gagal mengunduh data. Silakan coba lagi.'
};

/**
 * Success messages
 */
export const SUCCESS_MESSAGES = {
  DATA_LOADED: 'Data berhasil dimuat.',
  EXPORT_SUCCESS: 'Data berhasil diekspor.',
  SETTINGS_SAVED: 'Pengaturan berhasil disimpan.'
};

/**
 * Loading states
 */
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
} as const;

export type LoadingState = typeof LOADING_STATES[keyof typeof LOADING_STATES];
